import React from 'react';
import ExclamationTriangle from '../Icons/ExclamationTriangle';
import Check from '../Icons/Check';

import styles from './ValidationIcons.module.scss';

export interface IValidationIcons {
  isValid: boolean | undefined;
}

export default function ValidationIcons({ isValid }: IValidationIcons) {
  return (
    <div className={styles.validationIcons}>
      {isValid === false && <InValidIcon />}
      {isValid === true && <ValidIcon />}
    </div>
  );
}

const InValidIcon = () => (
  <ExclamationTriangle
    className={[styles.validationIcon, styles.exclamationTriangleIcon].join(' ')}
  />
);

const ValidIcon = () => <Check className={[styles.validationIcon, styles.checkIcon].join(' ')} />;
